/**
 * Columnar format for forms - holds form sections generally
 */
import React from 'react'
import PropTypes from 'prop-types'
// Using this here is a bit of a hack but I don't see the need to make another component for it
import { FieldTooltip, Grid as SemanticGrid } from '@adc/ui-core'
import classnames from 'classnames/bind'
import styles from '../styles.scss'
import requiredIf from '../../../utils/requiredIf'
const cx = classnames.bind(styles)

const FormSectionHeader = ({ subsection = false, children }) => {
  return subsection ? (
    <h3 className={cx('form-section-header')}>{children}</h3>
  ) : (
    <h2 className={cx('form-section-header')}>{children}</h2>
  )
}

FormSectionHeader.propTypes = {
  subsection: PropTypes.bool,
  children: PropTypes.node.isRequired,
}

const FormSection = ({
  children,
  className,
  title,
  helpContent,
  elmId,
  viewMode = false,
  borderBottom = true,
  subsection = false,
  fill,
  ...rest
}) => {
  return (
    <SemanticGrid.Row
      className={cx(
        'form-section',
        {
          'view-mode': viewMode,
          'border-bottom': borderBottom,
          'form-section--fill': fill,
        },
        className
      )}
      data-elm-id={elmId}
      {...rest}
    >
      {title && (
        <FormSectionHeader subsection={subsection}>
          {/*
            React.Children.toArray assigns stable keys to array items, so a
            `title` passed as an array of elements does not trigger a missing-key
            warning. A single-element or string title passes through unchanged.
          */}
          {React.Children.toArray(title)}
          {helpContent && (
            <FieldTooltip elmId={elmId} helpContent={helpContent} />
          )}
        </FormSectionHeader>
      )}
      {children}
    </SemanticGrid.Row>
  )
}

FormSection.propTypes = {
  ...SemanticGrid.Row.propTypes,
  title: PropTypes.node,
  helpContent: PropTypes.node,
  viewMode: PropTypes.bool,
  borderBottom: PropTypes.bool,
  fill: PropTypes.bool,
  elmId: requiredIf(PropTypes.string, props => props.helpContent),
}

export default FormSection
